;(function ($) {


    $('.sfx-stickyBg__content').rolla([
        {
            selector: '.sfx-stickyBg__dim',
            property: 'opacity',
            unit: '',
            start_value: 0,
            start_time: 0,
            move: 0.65,
            duration: 0.6
        }
    ])


})(jQuery);
